export const MAX_FILE_SIZE_MB = 1024;
export const BYTES_PER_MB = 1048576; // 1024*1024

export const UPLOAD_FILE = 'uploadFile';
